import type { ReactElement } from "react";

import Svg, { Path } from "react-native-svg";

const CheckIllustrationSVG = ({
  height,
  width,
}: Partial<SizeDimensions>): ReactElement<Partial<SizeDimensions>, "svg"> => (
  <Svg fill="none" height={height} viewBox="0 0 240 240" width={width}>
    <Path
      d="M107.547 225.646C156.912 232.293 202.318 197.663 208.965 148.298C215.612 98.9326 180.981 53.5262 131.617 46.8796C82.2516 40.2329 36.8452 74.8629 30.1985 124.228C23.5519 173.593 58.1819 218.999 107.547 225.646Z"
      fill="#00EBBF"
    />
    <Path
      d="M179.238 12.2026C159.609 52.3627 140.608 92.8301 122.214 133.57C119.417 139.763 118.562 150.33 122.328 156.305C126.398 162.767 131.013 155.431 132.792 151.494C137.225 141.677 141.694 131.871 146.2 122.082C147.326 119.637 148.458 117.192 149.584 114.746C150.195 113.428 150.805 112.116 151.416 110.798C152.647 108.144 150.672 112.397 152.026 109.486C154.303 104.605 156.586 99.7176 158.874 94.844C168.048 75.3333 177.371 55.8937 186.838 36.5244C190.145 29.7637 192.055 20.6442 189.383 13.314C188.61 11.1983 187.472 8.23783 184.84 7.95339C182.402 7.68883 180.16 10.3279 179.238 12.2026Z"
      fill="#164356"
    />
    <Path
      d="M128.714 129.888C120.007 124.348 114.824 113.701 109.3 104.491C103.131 94.2072 97.4526 83.6394 92.2316 72.8468C91.2545 70.8246 88.9981 69.6869 86.8881 70.5868C84.4335 71.6313 82.5716 75.4229 81.7734 77.658C79.2286 84.7696 78.5148 93.4327 81.8869 100.392C87.277 111.539 93.1654 122.44 99.5659 133.042C105.44 142.77 111.585 154.846 121.438 161.112C127.098 164.713 130.688 154.477 131.52 150.617C132.406 146.503 132.914 142.064 132.182 137.892C131.732 135.317 131.129 131.41 128.721 129.882L128.714 129.888Z"
      fill="#164356"
    />
  </Svg>
);

export default CheckIllustrationSVG;
